<script setup>
useCustomMeta('top', '')
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const breadCrumbList = isWebViewFlag ? [] : getBreadCrumb()
const { data: mapPosition } = await useFetch('/api/wind/mapConfig', { query: { path: 'japan' } })
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <WindMap
          :map-position="mapPosition"
          area-en="japan"
        />
      </div>
      <template #main-bottom>
        <WindAreaList />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
